export const ROLES = {
  S_PREMIUM_ADMIN: "S-Premium Admin",
  S_LEASING_ADMIN: "S-Leasing Admin",
  // Sparkasse bank managers; same permissions as S-Leasing Admin.
  BANKA: "Banka",
  INSURANCE_COMPANY: "Osiguravajuće društvo",
};
export const BASE_URL = process.env.REACT_APP_BASE_URL;
// Must match maxOfferRequestFiles in the backend's utils/constants.js.
export const MAX_OFFER_REQUEST_FILES = 10;

